import { render, staticRenderFns } from "./cssk.vue?vue&type=template&id=0bfca776&scoped=true&"
import script from "./cssk.vue?vue&type=script&lang=js&"
export * from "./cssk.vue?vue&type=script&lang=js&"
import style0 from "./cssk.vue?vue&type=style&index=0&id=0bfca776&lang=stylus&scoped=true&"
import style1 from "./cssk.vue?vue&type=style&index=1&id=0bfca776&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfca776",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bfca776')) {
      api.createRecord('0bfca776', component.options)
    } else {
      api.reload('0bfca776', component.options)
    }
    module.hot.accept("./cssk.vue?vue&type=template&id=0bfca776&scoped=true&", function () {
      api.rerender('0bfca776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/video/cssk.vue"
export default component.exports